import type { Reservation } from '../../core/model/reservation';
import { readJson, storageKey, writeJson } from './storage';

const KEY = storageKey('reservations');

/**
 * Última copia conocida de "Mis reservas".
 *
 * Existe para un caso concreto: llegar al restaurante sin cobertura y necesitar el código de
 * confirmación. Sin caché, la pantalla sería un error de red justo cuando más se necesita el
 * dato.
 */
export function loadCachedReservations(): Reservation[] {
  return readJson<Reservation[]>(KEY) ?? [];
}

export function cacheReservations(reservations: readonly Reservation[]): void {
  writeJson(KEY, reservations);
}
